import React, { useState } from 'react';

// This component will act as a gatekeeper.
// It receives the correct password as a prop and the component to show (children).
function PasswordProtect({ password, children }) {
  const [input, setInput] = useState('');
  const [isAuthorized, setIsAuthorized] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Check if the entered password matches the correct one
    if (input === password) {
      setIsAuthorized(true);
    } else {
      alert('Incorrect password. Please try again.');
      setInput(''); // Clear the input field
    }
  };

  // If the user is authorized, show the protected component (the children).
  if (isAuthorized) {
    return <>{children}</>;
  }

  // --- STYLES for the password form ---
  const formContainerStyle = {
    maxWidth: '400px',
    margin: '50px auto',
    padding: '30px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    textAlign: 'center',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    marginBottom: '20px',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    width: '100%',
    padding: '10px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  };

  // If not authorized, show the password entry form.
  return (
    <div style={formContainerStyle}>
      <h3>Access Required</h3>
      <p>Please enter the password to manage customers.</p>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Enter password"
          style={inputStyle}
          required
        />
        <button type="submit" style={buttonStyle}>
          Enter
        </button>
      </form>
    </div>
  );
}

export default PasswordProtect;